module.exports = __webpack_public_path__ + "dba14945afcf043f693426c3cfcefbfd.svg";